import React, {createContext, useContext, useEffect, useState} from "react";
import {TableDateSearchContext} from "../../admin/Context/TableDateSearchContext.jsx";
import {
    deliveriesPageSize,
    DeliveryProviderDeliveriesProjection
} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {useRequest} from "../../utils/hooks.jsx";

export const DriverDeliveriesContext = createContext({});

export const DriverDeliveriesProvider = ({children}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const {searchDate} = useContext(TableDateSearchContext);
    const [showDeliveredDeliveries, setShowDeliveredDeliveries] = useState(false);

    const [deliveries = {}, isLoading] = useRequest(
        "/api/deliveryProviders/mydeliveries",
        "POST",
        {
            startDate: searchDate[0].valueOf(),
            endDate: searchDate[1].valueOf(),
            page: currentPage,
            pageSize: deliveriesPageSize,
            projection: DeliveryProviderDeliveriesProjection,
            showDeliveredDeliveries
        },
        [currentPage, searchDate, showDeliveredDeliveries],
        !!searchDate
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [searchDate]);

    return (
        <DriverDeliveriesContext.Provider
            value={{
                deliveries: deliveries?.deliveries,
                totalDeliveriesCount: deliveries?.totalCount,
                currentPage,
                setCurrentPage,
                isLoading,
                searchDate,
                showDeliveredDeliveries,
                setShowDeliveredDeliveries
            }}>
            {children}
        </DriverDeliveriesContext.Provider>
    );
};
